var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaves(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 227,
    viewBox: "0 0 1440 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1440.56 120.444C1367.43 120.444 1366.94 66.7256 1296.75 66.7256C1226.55 66.7256 1225.96 120.444 1152.94 120.444C1079.91 120.444 1079.12 0.962272 1009.27 0.962272C939.41 0.962272 939.41 120.444 865.342 120.444C791.273 120.444 792.149 82.7795 721.53 82.7795C650.91 82.7795 650.712 120.444 577.746 120.444C504.78 120.444 504.158 66.7256 433.962 66.7256C363.767 66.7256 363.23 120.444 290.179 120.444C217.128 120.444 217.184 93.581 146.367 93.581C75.5491 93.581 75.4077 120.444 2.55469 120.444V119.482C73.3157 119.482 73.6267 92.6187 146.367 92.6187C219.107 92.6187 219.418 119.482 290.179 119.482C360.94 119.482 360.911 65.7633 433.962 65.7633C507.013 65.7633 507.55 119.482 577.746 119.482C647.942 119.482 648.564 81.8172 721.53 81.8172C794.496 81.8172 794.722 119.482 865.342 119.482C935.961 119.482 935.17 0 1009.27 0C1083.36 0 1083.11 119.482 1152.94 119.482C1222.77 119.482 1223.7 65.7633 1296.75 65.7633C1369.8 65.7633 1370.37 119.482 1440.56 119.482V120.444Z",
    fill: "url(#paint0_linear_123_107)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55469 120.452V119.49C73.4288 119.49 73.5984 95.1848 146.367 95.1848C219.135 95.1848 219.333 119.49 290.179 119.49C361.024 119.49 360.911 70.8874 433.962 70.8874C507.013 70.8874 507.466 119.49 577.718 119.49C648.196 119.49 648.705 85.4097 721.53 85.4097C794.524 85.4097 794.609 119.49 865.342 119.49C936.074 119.49 935.65 11.3789 1009.29 11.3789C1083.02 11.3789 1082.88 119.482 1152.94 119.482C1223.22 119.482 1223.67 70.8794 1296.75 70.8794C1369.83 70.8794 1370.28 119.482 1440.56 119.482V120.444C1367.51 120.444 1367.03 71.8416 1296.75 71.8416C1226.47 71.8416 1226.02 120.444 1152.94 120.444C1079.24 120.444 1079.32 12.3411 1009.29 12.3411C939.269 12.3411 938.986 120.444 865.342 120.444C792.347 120.444 792.262 86.3639 721.53 86.3639C650.797 86.3639 650.542 120.444 577.718 120.444C504.893 120.444 504.214 71.8416 433.962 71.8416C363.71 71.8416 363.23 120.444 290.179 120.444C217.495 120.444 217.241 96.139 146.367 96.139C75.436 96.139 75.2381 120.444 2.55469 120.444V120.452Z",
    fill: "url(#paint1_linear_123_107)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55469 120.452V119.49C73.5984 119.49 73.6267 97.7428 146.367 97.7428C219.107 97.7428 219.078 119.482 290.15 119.482C360.657 119.482 360.827 75.9954 433.934 75.9954C507.041 75.9954 507.183 119.482 577.689 119.482C648.309 119.482 648.705 88.9861 721.501 88.9861C794.411 88.9861 794.496 119.474 865.313 119.474C935.311 119.474 935.65 22.7497 1009.29 22.7497C1082.88 22.7497 1082.97 119.474 1152.91 119.474C1223.53 119.474 1223.53 75.9874 1296.75 75.9794C1369.88 75.9794 1370 119.466 1440.56 119.466V120.428C1367.43 120.428 1367.31 76.9417 1296.75 76.9417C1226.13 76.9417 1226.13 120.436 1152.91 120.436C1079.29 120.436 1079.24 23.712 1009.29 23.712C939.297 23.712 938.958 120.436 865.313 120.436C792.404 120.436 792.319 89.9484 721.501 89.9484C650.882 89.9484 650.486 120.444 577.689 120.444C504.582 120.444 504.441 76.9577 433.934 76.9577C363.427 76.9577 363.258 120.452 290.15 120.452C217.41 120.452 217.439 98.7131 146.367 98.7131C75.3229 98.7131 75.2664 120.46 2.55469 120.46V120.452Z",
    fill: "url(#paint2_linear_123_107)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55469 120.452V119.49C73.655 119.49 73.7115 100.301 146.367 100.301C219.05 100.301 218.993 119.482 290.15 119.482C360.827 119.482 360.855 81.1115 433.962 81.1035C506.815 81.1035 507.239 119.474 577.718 119.474C648.479 119.474 648.79 92.5706 721.53 92.5706C794.241 92.5706 794.581 119.474 865.342 119.474C935.368 119.474 935.763 34.1286 1009.32 34.1286C1082.97 34.1286 1082.74 119.474 1152.94 119.474C1223.5 119.474 1223.78 81.1035 1296.78 81.0955C1369.66 81.0955 1370.08 119.466 1440.59 119.466V120.428C1367.71 120.428 1367.28 82.0578 1296.78 82.0578C1226.21 82.0578 1225.96 120.428 1152.94 120.436C1079.01 120.436 1079.69 35.0909 1009.32 35.0909C939.297 35.0909 938.901 120.436 865.342 120.436C792.63 120.436 792.319 93.5329 721.53 93.5329C650.769 93.5329 650.458 120.436 577.718 120.444C504.865 120.444 504.441 82.0738 433.962 82.0738C363.286 82.0738 363.258 120.444 290.15 120.452C217.439 120.452 217.523 101.271 146.367 101.271C75.2098 101.271 75.2381 120.46 2.55469 120.46V120.452Z",
    fill: "url(#paint3_linear_123_107)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55469 120.46V119.498C73.8246 119.498 73.768 102.867 146.367 102.867C219.078 102.867 218.796 119.49 290.15 119.49C360.713 119.49 361.166 86.2356 433.962 86.2276C506.759 86.2276 507.155 119.482 577.689 119.482C648.677 119.482 648.761 96.1631 721.501 96.1631C794.185 96.1631 794.326 119.482 865.285 119.474C935.283 119.474 935.99 45.5074 1009.29 45.5074C1082.57 45.5074 1082.85 119.474 1152.88 119.466C1223.44 119.466 1223.87 86.2116 1296.72 86.2035C1369.66 86.2035 1369.8 119.458 1440.5 119.458V120.42C1367.57 120.42 1367.43 87.1658 1296.72 87.1658C1226.07 87.1658 1225.82 120.42 1152.88 120.428C1079.58 120.428 1079.29 46.4617 1009.29 46.4697C939.297 46.4697 938.59 120.436 865.285 120.436C792.602 120.436 792.46 97.1173 721.501 97.1253C650.627 97.1253 650.345 120.444 577.689 120.444C504.893 120.444 504.497 87.1899 433.962 87.1899C363.343 87.1899 363.032 120.444 290.15 120.452C217.58 120.452 217.58 103.829 146.367 103.829C110.944 103.829 93.6987 107.823 75.436 112.049C57.5408 116.186 39.0519 120.46 2.55469 120.46Z",
    fill: "url(#paint4_linear_123_107)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55469 120.46V119.498C73.8811 119.498 73.8811 105.425 146.367 105.425C218.852 105.425 218.796 119.49 290.122 119.49C360.855 119.49 361.166 91.3437 433.934 91.3437C506.73 91.3437 506.872 119.482 577.661 119.482C648.761 119.482 648.818 99.7475 721.473 99.7475C794.185 99.7475 794.1 119.474 865.257 119.474C935.509 119.474 936.018 56.8863 1009.29 56.8863C1082.57 56.8863 1082.69 119.466 1152.85 119.466C1223.61 119.466 1223.92 91.3196 1296.72 91.3196C1369.52 91.3196 1369.72 119.458 1440.5 119.458V120.42C1367.71 120.42 1367.51 92.2819 1296.72 92.2819C1225.96 92.2819 1225.65 120.428 1152.85 120.428C1079.6 120.428 1079.41 57.8486 1009.29 57.8486C939.014 57.8486 938.59 120.436 865.257 120.436C792.545 120.436 792.658 100.71 721.473 100.71C650.373 100.71 650.316 120.444 577.661 120.444C504.893 120.444 504.695 92.306 433.934 92.306C363.201 92.306 362.89 120.452 290.122 120.452C217.608 120.452 217.721 106.387 146.367 106.387C75.0402 106.387 75.0402 120.46 2.55469 120.46Z",
    fill: "url(#paint5_linear_123_107)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55469 120.468V119.506C73.4571 119.506 74.3335 107.991 146.395 107.991C155.724 108.496 174.383 106.652 219.022 113.797C236.521 116.595 254.614 119.498 290.15 119.498C360.968 119.498 361.364 96.4758 433.991 96.4678C506.617 96.4678 506.787 119.482 577.689 119.482C649.072 119.482 648.79 103.34 721.53 103.332C794.185 103.332 793.959 119.466 865.285 119.466C935.537 119.466 936.216 68.2572 1009.32 68.2572C1082.43 68.2572 1082.63 119.458 1152.88 119.458C1223.84 119.458 1224.01 96.4357 1296.75 96.4277C1369.43 96.4277 1369.55 119.442 1440.5 119.442V120.404C1367.76 120.404 1367.76 97.3819 1296.75 97.39C1225.88 97.39 1225.54 120.42 1152.88 120.42C1079.74 120.42 1079.6 69.2194 1009.32 69.2194C939.071 69.2194 938.364 120.428 865.285 120.436C792.545 120.436 792.969 104.302 721.53 104.302C650.147 104.302 650.429 120.444 577.689 120.452C505.034 120.452 504.949 97.4381 433.991 97.4381C363.145 97.4381 362.805 120.46 290.15 120.468C218.032 120.468 217.467 108.961 146.423 108.961C137.235 109.458 118.973 107.662 75.2098 114.663C57.3712 117.517 38.9105 120.476 2.55469 120.476V120.468Z",
    fill: "url(#paint6_linear_123_107)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55464 120.468V119.506C73.3439 119.506 74.6444 110.549 146.395 110.549C155.328 110.926 174.383 109.515 218.88 115.056C236.408 117.237 254.501 119.49 290.122 119.49H290.15C361.364 119.49 361.364 101.576 433.99 101.576C506.617 101.576 506.476 119.474 577.661 119.474C649.129 119.474 648.959 106.916 721.501 106.908C793.958 106.908 793.817 119.458 865.228 119.458C935.792 119.458 936.216 79.628 1009.29 79.62C1082.46 79.62 1082.12 119.442 1152.8 119.442C1224.01 119.442 1224.04 101.528 1296.66 101.528C1369.32 101.528 1369.21 119.426 1440.39 119.426V120.388C1367.74 120.388 1367.88 102.49 1296.66 102.49C1225.45 102.49 1225.45 120.404 1152.8 120.404C1079.66 120.404 1079.97 80.5823 1009.29 80.5823C938.732 80.5823 938.308 120.412 865.228 120.412C856.295 119.883 837.156 121.864 792.545 114.069C774.254 110.878 756.981 107.863 721.473 107.863C650.005 107.863 650.175 120.42 577.633 120.428C505.006 120.428 505.147 102.53 433.962 102.53C362.749 102.53 362.749 120.444 290.122 120.444H290.094C218.513 120.444 217.241 111.495 146.395 111.495C137.094 111.888 118.972 110.469 75.0401 115.938C57.2297 118.159 38.7974 120.452 2.52637 120.452L2.55464 120.468Z",
    fill: "url(#paint7_linear_123_107)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55469 120.476V119.514C73.5419 119.514 74.7292 113.115 146.395 113.115C155.95 113.404 174.185 112.369 218.739 116.331C236.295 117.894 254.445 119.506 290.122 119.506H290.179C361.618 119.506 361.477 106.708 434.019 106.708C506.476 106.708 506.306 119.49 577.661 119.49C586.934 119.097 605.112 120.517 649.016 115.04C666.854 112.818 685.287 110.517 721.558 110.517H721.614C793.195 110.517 794.383 119.474 865.285 119.474H865.341C936.018 119.474 936.696 91.0229 1009.44 91.0149C1082.12 91.0149 1082.23 119.458 1152.91 119.458C1224.38 119.458 1224.24 106.66 1296.78 106.66H1296.81C1369.29 106.66 1369.09 119.442 1440.5 119.442H1440.53V120.404H1440.5C1368.05 120.404 1368.22 107.622 1296.81 107.622H1296.78C1225.31 107.622 1225.45 120.42 1152.91 120.42C1080.23 120.42 1080.11 91.9772 1009.44 91.9772C938.788 91.9772 938.081 120.428 865.341 120.436C855.843 120.035 837.439 121.479 792.856 115.922C775.357 113.733 757.235 111.479 721.643 111.479H721.586C650.825 111.479 649.468 120.452 577.746 120.452H577.718C505.289 120.452 505.458 107.67 434.075 107.67H434.047C362.608 107.67 362.749 120.468 290.207 120.468C280.651 120.18 262.417 121.214 217.863 117.253C200.307 115.689 182.157 114.077 146.48 114.077C137.207 114.358 118.916 113.348 74.9554 117.261C57.1733 118.841 38.7692 120.476 2.58296 120.484L2.55469 120.476Z",
    fill: "url(#paint8_linear_123_107)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55469 120.476V119.514C74.0225 119.514 74.5313 115.673 146.395 115.665C155.13 115.825 174.27 115.224 218.541 117.59C261.738 119.891 290.659 119.498 290.15 119.498C361.307 119.498 362.127 111.816 434.019 111.816H434.075C505.769 111.816 506.617 119.482 577.661 119.482H577.718C648.818 119.482 649.892 114.101 721.558 114.093H721.643C793.28 114.093 794.072 119.466 865.228 119.466H865.313C936.668 119.466 936.696 102.394 1009.44 102.386H1009.46C1082.03 102.386 1081.7 119.442 1152.88 119.442C1162.12 119.105 1180.36 120.316 1224.32 115.625C1242.13 113.725 1260.56 111.76 1296.81 111.76H1296.86C1368.58 111.76 1369.4 119.426 1440.48 119.426H1440.53V120.388H1440.48C1368.75 120.388 1367.93 112.722 1296.86 112.722H1296.81C1225.65 112.722 1224.8 120.404 1152.91 120.404C1080.34 120.404 1080.68 103.348 1009.49 103.348H1009.46C920.13 103.348 945.771 129.153 793.082 117.726C750.224 114.518 721.077 115.04 721.586 115.056C650.486 115.056 649.412 120.436 577.746 120.444C568.275 120.108 549.871 121.334 505.373 116.579C487.846 114.711 469.753 112.77 434.104 112.77H434.047C362.919 112.77 362.042 120.452 290.179 120.452H290.065C218.428 120.452 217.806 116.619 146.536 116.619C75.2664 116.619 74.39 120.46 2.58296 120.468L2.55469 120.476Z",
    fill: "url(#paint9_linear_123_107)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55469 120.484V119.522C82.8994 119.522 115.156 117.044 218.372 118.873C374.453 121.647 383.669 113.869 506.052 118.215C597.451 121.463 643.984 117.686 721.841 117.686C793.11 117.686 793.959 119.466 865.059 119.466C936.159 119.466 937.375 113.773 1009.46 113.765C1018.85 114.013 1037.37 113.107 1081.61 116.619C1161.76 122.986 1214.26 116.876 1297.03 116.876C1368.64 116.876 1368.98 119.426 1440.59 119.426V120.388C1362 120.388 1328.67 115.433 1225.08 119.121C1087.1 124.037 1095.29 114.727 1009.58 114.727H1009.46C938.223 114.727 937.12 120.42 865.342 120.428C787.711 120.428 752.514 116.98 649.779 119.546C531.524 122.505 515.325 117.902 434.217 117.902C347.031 117.902 353.109 122.225 218.174 119.835C115.297 118.007 80.1572 120.484 2.55469 120.484Z",
    fill: "url(#paint10_linear_123_107)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1555 120H2.95117V121H1555V120Z",
    fill: "#010101"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M988.714 134.213C850.669 134.213 849.793 14.7308 713.246 14.7308C576.7 14.7308 575.343 134.213 437.27 134.213C299.197 134.213 298.575 96.548 161.52 96.548C79.507 96.548 45.7803 110.14 3.60074 120.805L2.58301 120.484C45.2714 109.683 78.9416 96.115 161.548 96.115C230.782 96.115 265.951 105.722 299.96 115.008C333.743 124.237 368.686 133.78 437.298 133.78C573.873 133.78 575.202 14.2978 713.275 14.2978C851.348 14.2978 852.196 133.78 988.742 133.78C1125.29 133.78 1126.79 80.061 1264.49 80.061C1357.79 80.061 1388.83 104.735 1440.56 120.501L1439.43 120.797C1387.61 105.008 1356.82 80.4941 1264.49 80.4941C1127.86 80.4941 1126.45 134.213 988.742 134.213H988.714Z",
    fill: "url(#paint11_linear_123_107)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M988.714 132.946C850.556 132.946 849.991 24.8427 713.246 24.8427C576.502 24.8427 575.315 132.946 437.27 132.946C299.225 132.946 298.547 98.8654 161.52 98.8654C79.5636 98.8654 45.8652 111.134 3.57252 120.813L2.61133 120.476C45.3563 110.693 78.9982 98.4244 161.548 98.4244C230.782 98.4244 265.923 107.117 299.932 115.521C333.715 123.868 368.658 132.505 437.298 132.505C573.901 132.505 575.23 24.4016 713.275 24.4016C851.319 24.4016 851.998 132.505 988.742 132.505C1125.49 132.505 1126.76 83.9021 1264.49 83.9021C1357.76 83.9021 1388.8 106.227 1440.53 120.493L1439.46 120.805C1387.7 106.532 1356.82 84.3431 1264.49 84.3431C1127.72 84.3431 1126.48 132.946 988.742 132.946H988.714Z",
    fill: "url(#paint12_linear_123_107)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M988.714 131.671C850.641 131.671 849.962 34.9465 713.246 34.9465C576.53 34.9465 575.258 131.671 437.27 131.671C299.282 131.671 298.462 101.175 161.52 101.175C80.0724 101.175 46.9677 111.928 3.51598 120.821L2.61133 120.468C45.2149 111.744 78.9133 100.742 161.491 100.742C230.698 100.742 265.838 108.512 299.847 116.034C333.63 123.508 368.573 131.238 437.242 131.238C573.873 131.238 575.23 34.5135 713.218 34.5135C851.206 34.5135 851.97 131.238 988.686 131.238C1125.4 131.238 1126.76 87.7512 1264.44 87.7512C1357.73 87.7512 1388.63 107.71 1440.45 120.484L1439.43 120.813C1387.64 108.031 1356.8 88.1842 1264.41 88.1842C1195.82 88.1842 1160.88 99.2022 1127.1 109.859C1093.09 120.589 1057.95 131.679 988.657 131.679L988.714 131.671Z",
    fill: "url(#paint13_linear_123_107)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M988.714 130.404C850.698 130.404 849.962 45.0584 713.246 45.0584C576.53 45.0584 575.315 130.404 437.27 130.404C299.225 130.404 298.519 103.5 161.52 103.5C79.9595 103.5 46.7134 113.027 3.48782 120.837L2.66797 120.468C45.6108 112.714 79.0548 103.067 161.52 103.067C230.698 103.067 265.838 109.924 299.819 116.555C333.602 123.147 368.573 129.971 437.27 129.971C574.014 129.971 575.202 44.6254 713.246 44.6254C851.291 44.6254 851.998 129.971 988.714 129.971C1125.43 129.971 1126.56 91.6003 1264.46 91.6003C1357.64 91.6003 1388.71 109.226 1440.45 120.484L1439.52 120.829C1387.75 109.563 1356.91 92.0413 1264.46 92.0413C1195.85 92.0413 1160.91 101.76 1127.13 111.166C1093.12 120.629 1057.98 130.412 988.714 130.412V130.404Z",
    fill: "url(#paint14_linear_123_107)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M988.714 129.129C850.726 129.129 850.019 55.1622 713.247 55.1622C576.474 55.1622 575.117 129.129 437.27 129.129C299.423 129.129 298.434 105.81 161.52 105.81C80.2988 105.81 47.4485 113.949 3.43132 120.837L2.69629 120.452C45.4978 113.749 79.0266 105.377 161.52 105.377C230.669 105.377 265.81 111.319 299.791 117.068C333.602 122.786 368.545 128.696 437.27 128.696C573.845 128.696 575.4 54.7292 713.247 54.7292C851.094 54.7292 851.942 128.696 988.714 128.696C1125.49 128.696 1126.7 95.4413 1264.46 95.4413C1357.62 95.4413 1388.68 110.709 1440.42 120.468L1439.57 120.829C1387.72 111.046 1356.94 95.8744 1264.49 95.8744C1127.49 95.8744 1126.5 129.129 988.742 129.129H988.714Z",
    fill: "url(#paint15_linear_123_107)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M988.714 127.862C850.783 127.862 850.048 65.2741 713.247 65.2741C576.446 65.2741 575.174 127.862 437.27 127.862C299.367 127.862 298.575 108.127 161.52 108.127C81.5145 108.127 49.6537 114.711 3.40315 120.845L2.75293 120.452C45.5262 114.791 79.2528 107.694 161.52 107.694C230.641 107.694 265.781 112.722 299.734 117.582C333.546 122.417 368.516 127.421 437.27 127.421C574.043 127.421 575.343 64.8331 713.247 64.8331C851.15 64.8331 851.913 127.421 988.714 127.421C1125.52 127.421 1126.84 99.2824 1264.46 99.2824C1357.62 99.2824 1388.6 112.193 1440.36 120.452L1439.6 120.829C1387.78 112.554 1356.97 99.7155 1264.46 99.7155C1127.49 99.7155 1126.33 127.854 988.714 127.854V127.862Z",
    fill: "url(#paint16_linear_123_107)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M988.714 126.587C850.839 126.587 850.132 75.378 713.247 75.378C576.361 75.378 575.004 126.587 437.27 126.587C299.536 126.587 298.83 110.445 161.52 110.445C81.6842 110.445 49.993 115.785 3.34666 120.853L2.78125 120.444C45.7807 115.785 78.9985 110.012 161.492 110.012C230.585 110.012 265.697 114.125 299.65 118.103C333.461 122.064 368.432 126.154 437.242 126.154C573.958 126.154 575.485 74.945 713.218 74.945C850.952 74.945 851.8 126.154 988.686 126.154C1125.57 126.154 1126.9 103.132 1264.44 103.132C1357.5 103.132 1388.57 113.7 1440.28 120.452L1439.63 120.845C1387.64 114.061 1357.11 103.565 1264.44 103.565C1127.47 103.565 1126.22 126.587 988.686 126.587H988.714Z",
    fill: "url(#paint17_linear_123_107)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M988.714 125.312C851.009 125.312 850.104 85.4819 713.247 85.4819C576.39 85.4819 575.174 125.312 437.27 125.312C299.367 125.312 298.717 112.754 161.52 112.754C79.9033 112.754 46.6855 117.197 3.29027 120.853L2.86621 120.436C46.1201 116.788 79.1965 112.321 161.52 112.321C230.585 112.321 265.697 115.521 299.621 118.608C333.461 121.687 368.46 124.879 437.27 124.879C574.297 124.879 575.344 85.0488 713.247 85.0488C851.15 85.0488 851.857 124.879 988.714 124.879C1125.57 124.879 1127.1 106.973 1264.46 106.973C1357.47 106.973 1388.54 115.192 1440.25 120.436L1439.74 120.845C1387.75 115.561 1357.05 107.406 1264.46 107.406C1127.55 107.406 1126.08 125.312 988.714 125.312Z",
    fill: "url(#paint18_linear_123_107)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M988.714 124.045C851.263 124.045 850.075 95.5937 713.246 95.5937C576.417 95.5937 574.805 124.045 437.27 124.045C299.734 124.045 298.942 115.08 161.519 115.08C79.6762 115.08 46.2888 118.271 3.23285 120.861L2.92188 120.436C46.4019 117.814 79.4501 114.647 161.519 114.647C230.556 114.647 265.639 116.932 299.564 119.137C590.298 138.046 540.74 95.1687 713.246 95.1687C850.697 95.1687 851.884 123.62 988.714 123.62C1125.54 123.62 1126.96 110.83 1264.46 110.83C1357.42 110.83 1388.46 116.692 1440.19 120.444L1439.8 120.869C1387.95 117.109 1357.13 111.271 1264.46 111.271C1127.3 111.271 1126.22 124.061 988.714 124.061V124.045Z",
    fill: "url(#paint19_linear_123_107)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M988.714 122.77C851.319 122.77 850.245 105.698 713.246 105.698C576.247 105.698 574.806 122.77 437.27 122.77C265.583 122.77 251.928 111.88 3.17641 120.861L2.97852 120.428C48.2961 118.793 79.7046 116.956 161.519 116.956C230.499 116.956 265.583 118.327 299.508 119.651C590.92 131.021 540.033 105.273 713.246 105.273C850.641 105.273 851.715 122.345 988.714 122.345C1125.71 122.345 1127.04 114.671 1264.46 114.671C1357.36 114.671 1388.35 118.183 1440.11 120.436L1439.88 120.869C1397.31 119.017 1288.07 109.964 1126.76 118.945C1092.83 120.829 1057.75 122.786 988.742 122.786L988.714 122.77Z",
    fill: "url(#paint20_linear_123_107)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M713.246 115.809C575.993 115.809 574.664 121.503 437.27 121.503C267.025 121.503 250.289 117.886 3.0917 120.861L3.03516 120.428C320.993 116.595 401.564 125.376 575.145 118.223C668.409 114.382 757.207 114.342 851.093 118.223C1043.9 126.194 1136.54 114.863 1402.54 119.787C1414.35 120.003 1426.57 120.228 1440.02 120.428L1439.94 120.861C1383.23 120.043 1283.46 117.317 1126.62 120.22C859.348 125.176 882.134 115.809 713.246 115.809Z",
    fill: "url(#paint21_linear_123_107)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M713.246 125.921C575.71 125.921 574.664 120.236 437.27 120.236C267.336 120.236 250.656 123.852 3.03516 120.869L3.0917 120.436C321.417 124.277 401.564 115.489 575.343 122.65C609.267 124.045 644.351 125.488 713.218 125.488C883.095 125.488 859.405 116.122 1126.59 121.078C1281.51 123.949 1382.66 121.262 1439.91 120.428L1440 120.861C1383.23 121.687 1283.83 124.43 1126.5 121.511C868.649 116.724 875.462 125.921 713.218 125.921H713.246Z",
    fill: "url(#paint22_linear_123_107)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M713.246 136.025C575.852 136.025 574.297 118.953 437.27 118.953C266.261 118.953 251.589 129.843 2.97852 120.853L3.17641 120.42C47.872 122.032 79.7046 123.893 161.548 123.893C230.443 123.893 265.442 122.529 299.31 121.206C590.948 109.819 540.711 135.584 713.246 135.584C850.245 135.584 851.291 118.512 988.714 118.512C1057.72 118.512 1092.81 120.46 1126.73 122.353C1220.02 127.549 1308.74 127.557 1402.14 122.353C1414.01 121.695 1426.31 121.006 1439.85 120.42L1440.08 120.853C1388.37 123.107 1357.39 126.627 1264.44 126.627C1126.84 126.627 1126.08 118.953 988.685 118.953C851.291 118.953 850.669 136.025 713.218 136.025H713.246Z",
    fill: "url(#paint23_linear_123_107)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M713.247 146.137C575.796 146.137 574.071 117.686 437.27 117.686C300.47 117.686 298.971 126.651 161.52 126.651C79.9033 126.651 46.7986 123.5 2.89453 120.853L3.20551 120.428C47.1944 123.075 79.6489 126.218 161.492 126.218C230.331 126.218 265.358 123.941 299.197 121.743C590.949 102.763 540.854 145.704 713.219 145.704C850.076 145.704 851.122 117.253 988.686 117.253C1126.25 117.253 1127.24 130.043 1264.44 130.043C1357.08 130.043 1387.92 124.197 1439.77 120.428L1440.14 120.853C1388.46 124.598 1357.42 130.476 1264.41 130.476C1126.9 130.476 1125.85 117.686 988.658 117.686C919.989 117.686 885.103 124.895 851.377 131.871C817.452 138.888 782.368 146.137 713.19 146.137H713.247Z",
    fill: "url(#paint24_linear_123_107)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M713.247 156.241C575.598 156.241 574.071 116.411 437.27 116.411C300.47 116.411 298.999 128.969 161.52 128.969C79.6205 128.969 46.3179 124.518 2.83789 120.853L3.26195 120.436C47.3639 124.157 79.7901 128.535 161.492 128.535C298.66 128.535 299.763 115.978 437.242 115.978C506.477 115.978 541.702 126.138 575.768 135.961C609.607 145.72 644.606 155.808 713.219 155.808C850.133 155.808 850.924 115.978 988.686 115.978C1126.45 115.978 1127.18 133.884 1264.44 133.884C1357.14 133.884 1387.84 125.705 1439.71 120.428L1440.22 120.837C1387.89 126.154 1357.59 134.317 1264.44 134.317C1126.84 134.317 1125.94 116.411 988.686 116.411C920.074 116.411 885.216 126.499 851.49 136.258C817.565 146.081 782.453 156.241 713.219 156.241H713.247Z",
    fill: "url(#paint25_linear_123_107)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M713.247 166.353C575.372 166.353 574.128 115.144 437.27 115.144C300.413 115.144 299.169 131.286 161.52 131.286C81.9669 131.286 51.1521 126.082 2.78125 120.845L3.34666 120.436C47.4203 125.216 79.8749 130.845 161.52 130.845C298.773 130.845 299.621 114.703 437.27 114.703C506.561 114.703 541.815 127.766 575.852 140.395C609.692 152.937 644.691 165.912 713.219 165.912C850.048 165.912 850.839 114.703 988.686 114.703C1126.53 114.703 1127.55 137.725 1264.44 137.725C1356.99 137.725 1387.84 127.196 1439.66 120.436L1440.31 120.829C1388.54 127.589 1357.53 138.158 1264.46 138.158C1127.04 138.158 1125.6 115.136 988.714 115.136C920.158 115.136 885.301 128.11 851.602 140.652C817.65 153.282 782.566 166.337 713.247 166.337V166.353Z",
    fill: "url(#paint26_linear_123_107)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M713.247 176.457C575.287 176.457 574.099 113.869 437.27 113.869C300.441 113.869 299.112 133.595 161.52 133.595C81.0904 133.595 49.2579 126.988 2.75293 120.837L3.40315 120.444C46.2329 126.122 79.6769 133.162 161.52 133.162C298.66 133.162 299.678 113.436 437.27 113.436C506.618 113.436 541.843 129.394 575.909 144.83C609.748 160.162 644.747 176.024 713.247 176.024C850.019 176.024 850.811 113.436 988.714 113.436C1126.62 113.436 1127.47 141.574 1264.46 141.574C1356.99 141.574 1387.87 128.712 1439.63 120.444L1440.39 120.821C1388.66 129.073 1357.59 142.007 1264.46 142.007C1126.82 142.007 1125.71 113.869 988.714 113.869C920.215 113.869 885.357 129.722 851.631 145.063C817.706 160.499 782.622 176.457 713.247 176.457Z",
    fill: "url(#paint27_linear_123_107)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M713.247 186.569C575.343 186.569 573.93 112.602 437.27 112.602C300.611 112.602 299.056 135.921 161.52 135.921C79.8182 135.921 46.77 127.734 2.69629 120.837L3.43132 120.452C46.1763 127.148 79.3658 135.48 161.52 135.48C298.49 135.48 299.734 112.161 437.27 112.161C506.646 112.161 541.871 131.021 575.937 149.256C609.777 167.379 644.776 186.127 713.247 186.127C850.132 186.127 850.585 112.161 988.714 112.161C1126.84 112.161 1127.44 145.415 1264.46 145.415C1333.11 145.415 1368.05 136.987 1401.83 128.84C1413.7 125.977 1426 123.01 1439.57 120.452L1440.42 120.813C1388.66 130.572 1357.62 145.848 1264.46 145.848C1126.7 145.848 1125.74 112.594 988.714 112.594C920.243 112.594 885.386 131.334 851.659 149.457C817.734 167.7 782.651 186.552 713.247 186.552V186.569Z",
    fill: "url(#paint28_linear_123_107)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M713.246 196.672C575.23 196.672 573.986 111.327 437.27 111.327C300.554 111.327 299.254 138.23 161.52 138.23C79.394 138.23 46.0348 128.656 2.63965 120.821L3.45949 120.452C46.0348 128.143 79.4505 137.789 161.491 137.789C298.575 137.789 299.508 110.886 437.242 110.886C506.674 110.886 541.871 132.641 575.937 153.683C609.776 174.604 644.804 196.231 713.218 196.231C849.962 196.231 850.613 110.886 988.686 110.886C1126.76 110.886 1127.55 149.256 1264.44 149.256C1333.05 149.256 1367.99 139.537 1401.77 130.131C1413.65 126.827 1425.92 123.411 1439.52 120.452L1440.45 120.797C1388.71 132.056 1357.64 149.689 1264.44 149.689C1126.73 149.689 1125.57 111.319 988.686 111.319C920.243 111.319 885.385 132.946 851.659 153.867C817.734 174.909 782.65 196.664 713.218 196.664L713.246 196.672Z",
    fill: "url(#paint29_linear_123_107)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M713.246 206.784C575.145 206.784 574.014 110.06 437.27 110.06C300.526 110.06 299.14 140.556 161.52 140.556C82.0231 140.556 51.1235 130.757 2.61133 120.821L3.51598 120.468C45.7803 129.113 79.507 140.115 161.52 140.115C298.434 140.115 299.649 109.619 437.27 109.619C574.891 109.619 576.502 206.343 713.246 206.343C849.991 206.343 850.697 109.619 988.714 109.619C1126.73 109.619 1127.47 153.106 1264.46 153.106C1333.05 153.106 1367.99 142.088 1401.77 131.43C1413.65 127.685 1425.92 123.812 1439.49 120.468L1440.5 120.797C1388.74 133.563 1357.7 153.539 1264.46 153.539C1126.59 153.539 1125.71 110.052 988.714 110.052C920.299 110.052 885.414 134.566 851.687 158.278C817.762 182.118 782.679 206.776 713.246 206.776V206.784Z",
    fill: "url(#paint30_linear_123_107)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M713.246 216.888C575.089 216.888 573.986 108.785 437.27 108.785C300.554 108.785 299.282 142.865 161.52 142.865C78.9416 142.865 45.1584 130.54 2.58301 120.813L3.5442 120.476C45.8934 130.171 79.5918 142.432 161.52 142.432C298.518 142.432 299.508 108.352 437.27 108.352C575.032 108.352 576.502 216.455 713.246 216.455C849.991 216.455 850.669 108.352 988.714 108.352C1126.76 108.352 1127.64 156.955 1264.46 156.955C1333.05 156.955 1367.96 144.638 1401.75 132.729C1413.62 128.544 1425.89 124.213 1439.46 120.476L1440.53 120.789C1388.74 135.063 1357.76 157.388 1264.44 157.388C1126.65 157.388 1125.51 108.785 988.686 108.785C851.857 108.785 851.263 216.888 713.218 216.888H713.246Z",
    fill: "url(#paint31_linear_123_107)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M713.246 227C575.202 227 573.816 107.518 437.27 107.518C300.723 107.518 299.169 145.183 161.52 145.183C79.7331 145.183 46.7415 131.976 2.55469 120.805L3.57243 120.476C45.9499 131.19 79.5352 144.742 161.52 144.742C298.349 144.742 299.621 107.077 437.27 107.077C574.919 107.077 576.7 226.559 713.246 226.559C849.793 226.559 850.613 107.077 988.714 107.077C1126.82 107.077 1127.8 160.796 1264.46 160.796C1356.82 160.796 1387.75 136.234 1439.46 120.485L1440.59 120.781C1388.88 136.53 1357.81 161.237 1264.49 161.237C1126.84 161.237 1125.4 107.518 988.742 107.518C852.083 107.518 851.376 227 713.275 227H713.246Z",
    fill: "url(#paint32_linear_123_107)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_123_107",
    x1: 1558.96,
    y1: 60.2222,
    x2: 7.61505,
    y2: 60.2222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50B2E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#74C487"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FAED24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F79421"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1F62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_123_107",
    x1: -50.0001,
    y1: 65.9157,
    x2: -47.1731,
    y2: 65.9157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50B2E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#74C487"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FAED24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F79421"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1F62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_123_107",
    x1: -50.0001,
    y1: 71.6011,
    x2: -47.1731,
    y2: 71.6011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50B2E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#74C487"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FAED24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F79421"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1F62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_123_107",
    x1: -50.0001,
    y1: 77.2945,
    x2: -47.1731,
    y2: 77.2945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50B2E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#74C487"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FAED24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F79421"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1F62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_123_107",
    x1: -50.0001,
    y1: 82.9799,
    x2: -47.1731,
    y2: 82.9799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50B2E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#74C487"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FAED24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F79421"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1F62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_123_107",
    x1: -50.0001,
    y1: 88.6734,
    x2: -47.1731,
    y2: 88.6734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50B2E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#74C487"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FAED24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F79421"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1F62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_123_107",
    x1: -50.0001,
    y1: 94.3668,
    x2: -47.1731,
    y2: 94.3668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50B2E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#74C487"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FAED24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F79421"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1F62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_123_107",
    x1: -50.0002,
    y1: 100.052,
    x2: -47.1731,
    y2: 100.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50B2E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#74C487"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FAED24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F79421"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1F62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_123_107",
    x1: -50.0001,
    y1: 105.746,
    x2: -47.1731,
    y2: 105.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50B2E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#74C487"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FAED24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F79421"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1F62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_123_107",
    x1: -50.0001,
    y1: 111.519,
    x2: -47.1731,
    y2: 111.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50B2E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#74C487"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FAED24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F79421"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1F62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_123_107",
    x1: -50.0001,
    y1: 117.157,
    x2: -47.1731,
    y2: 117.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50B2E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#74C487"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FAED24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F79421"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1F62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_123_107",
    x1: -271.98,
    y1: 151.029,
    x2: 1084.87,
    y2: -895.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50B2E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_123_107",
    x1: -268.276,
    y1: 155.832,
    x2: 1088.62,
    y2: -891.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50B2E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_123_107",
    x1: -264.573,
    y1: 160.635,
    x2: 1092.27,
    y2: -886.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50B2E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_123_107",
    x1: -260.869,
    y1: 165.431,
    x2: 1096.03,
    y2: -881.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50B2E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_123_107",
    x1: -257.194,
    y1: 170.218,
    x2: 1099.74,
    y2: -876.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50B2E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_123_107",
    x1: -253.491,
    y1: 174.989,
    x2: 1103.41,
    y2: -871.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50B2E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_123_107",
    x1: -250.126,
    y1: 179.36,
    x2: 1106.72,
    y2: -867.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50B2E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_123_107",
    x1: -249.476,
    y1: 180.202,
    x2: 1107.37,
    y2: -866.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50B2E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_123_107",
    x1: -248.968,
    y1: 180.851,
    x2: 1107.93,
    y2: -866.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50B2E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_123_107",
    x1: -248.968,
    y1: 180.883,
    x2: 1107.96,
    y2: -866.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50B2E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_123_107",
    x1: -248.94,
    y1: 180.891,
    x2: 1107.91,
    y2: -866.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A45FA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50B2E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_123_107",
    x1: -248.94,
    y1: 180.891,
    x2: 1107.96,
    y2: -866.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50B2E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_123_107",
    x1: -248.94,
    y1: 180.899,
    x2: 1107.91,
    y2: -866.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50B2E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_123_107",
    x1: -248.26,
    y1: 181.765,
    x2: 1108.64,
    y2: -865.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50B2E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_123_107",
    x1: -247.13,
    y1: 183.265,
    x2: 1109.75,
    y2: -863.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50B2E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_123_107",
    x1: -245.858,
    y1: 184.885,
    x2: 1111.04,
    y2: -862.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50B2E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_123_107",
    x1: -244.557,
    y1: 186.585,
    x2: 1112.29,
    y2: -860.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50B2E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_123_107",
    x1: -241.108,
    y1: 191.067,
    x2: 1115.77,
    y2: -855.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50B2E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_123_107",
    x1: -237.405,
    y1: 195.854,
    x2: 1119.44,
    y2: -851.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50B2E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_123_107",
    x1: -233.702,
    y1: 200.65,
    x2: 1123.14,
    y2: -846.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50B2E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_123_107",
    x1: -229.998,
    y1: 205.453,
    x2: 1126.88,
    y2: -841.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50B2E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_123_107",
    x1: -226.295,
    y1: 210.256,
    x2: 1130.61,
    y2: -836.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A45FA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50B2E5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaves);
export default __webpack_public_path__ + "static/media/waves.83000e6c5f1865f421af4beb9af6adcf.svg";
export { ForwardRef as ReactComponent };